import { render } from "./OpenGymView.vue?vue&type=template&id=f7e97d82&scoped=true"
import script from "./OpenGymView.vue?vue&type=script&lang=js"
export * from "./OpenGymView.vue?vue&type=script&lang=js"

import "./OpenGymView.vue?vue&type=style&index=0&id=f7e97d82&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7e97d82"]])

export default __exports__